/*
 * Kremi davranış ölçümü — tema toplayıcısı (ölçüm planı A5 + A11 istemci kısmı + deney istemcisi).
 *
 * Sözleşme: backend/docs/olcum/OLAY-SOZLESMESI.md + packages/core/src/contracts/behavior.ts (TEK KAYNAK).
 * Olay adı / sayfa türü / özellik kimliği değişirse ÖNCE sözleşme, sonra bu dosya.
 *
 * KVKK — hiçbir koşulda delinmez:
 *  - Shopify.customerPrivacy.analyticsProcessingAllowed() true DEĞİLSE hiçbir şey yapılmaz: çerez yok, kuyruk yok,
 *    istek yok, _ksid yok, deney yok. Karar `visitorConsentCollected` ile yeniden değerlendirilir; rıza geri
 *    alınınca kuyruk GÖNDERİLMEDEN boşaltılır, _kremi_vid + _kremi_sid silinir, sepetteki _ksid/_katt koşulsuz
 *    boşaltılır, dinleyiciler sökülür.
 *  - Kişisel veri yok: müşteri kimliği/e-posta/ad hiçbir olaya girmez; path'te query/hash yok (hesap/hediye
 *    kartı yollarındaki gizli parçalar da kırpılır); arama terimi yalnız isSafeSearchTerm kuralına uyuyorsa gider.
 *  - Reklam tıklama kimlikleri (gclid/gbraid/wbraid/msclkid/fbclid/ttclid/yclid) DEĞERİ hiçbir yere yazılmaz
 *    (olay, sessionStorage, sepet özniteliği): yalnız TÜRÜ + sayısal gad_campaignid/gad_source (parseClick).
 *
 * Performans: tek dosya, defer, bağımlılık yok. Tek belge-düzeyi click dinleyicisi, tek IntersectionObserver,
 * tek pasif scroll dinleyicisi; ağ işi 5 sn'lik kuyrukta toplanır (sendBeacon).
 *
 * Saf fonksiyonlar (fnv1a32, assignVariant, isSafeSearchTerm, cleanPath, normalizeUtmToken, normalizeUtmTerm,
 * parseUtm, parseClick, buildKatt, refHost, randomId, createRageDetector, pageTypeOf, clickPos, viewportClass, sectionRect)
 * module.exports ile node'da
 * test edilir:
 *   node scripts/tests/kremi-track.smoke.cjs
 */
(function (root, factory) {
  var api = factory(root);
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else if (root && root.document) api.start();
})(typeof window !== 'undefined' ? window : globalThis, function (win) {
  'use strict';

  // ── Sözleşme sabitleri (behavior.ts aynası) ───────────────────────────────────
  var PAGE_TYPES = ['home', 'product', 'collection', 'search', 'cart', 'checkout', 'page', 'blog', 'article', 'account',
    'wishlist', 'community', 'orders', 'profile', 'notifications', 'other'];
  var FEATURE_ID_RE = /^[a-z0-9-]+(\.[a-z0-9-]+){1,3}$/;
  var ID_RE = /^[A-Za-z0-9_-]{8,40}$/;
  var EXP_RE = /^[a-z0-9-]{2,40}$/;
  // Varyant adı: tek harf (a, b, c) olabilir. NOT: backend behavior.ts EXP_RE varyant için {2,40} ister → tek harfli
  // varyantın exposure'ı sunucuda `exp=null` düşer; sözleşmede varyant kalıbı {1,40}'a gevşetilmeli (rapora bkz.).
  var VARIANT_RE = /^[a-z0-9-]{1,40}$/;
  var MAX_BATCH = 50;
  var MAX_BODY = 15000; // sunucu sınırı 16 KB; payla bırak
  var MAX_PER_PAGE = 300; // bir sayfa ömründe üst sınır (kontrolsüz döngüye karşı emniyet)
  var FLUSH_MS = 5000;
  var SID_TTL = 30 * 60; // sn, kayan
  var VID_TTL = 365 * 24 * 60 * 60;
  var EVENT_URL = '/apps/kremi/e';
  var EXP_URL = '/apps/kremi/exp';
  var INTERACTIVE = 'a,button,input,select,textarea,label,summary,[role=button]';
  // Tıklama kimliği türleri — öncelik sırası (aynı URL'de birden çoksa ilki). behavior.ts CLICK_ID_TYPES aynası.
  var CLICK_ID_TYPES = ['gclid', 'gbraid', 'wbraid', 'msclkid', 'fbclid', 'ttclid', 'yclid'];
  var GAD_CAMPAIGN_RE = /^\d{1,20}$/;
  var GAD_SOURCE_RE = /^\d{1,3}$/;
  // Doldurulmamış reklam makrosu (küçük harften ÖNCE, ham metinde): {{campaign.name}} (Meta) · {lpurl} (Google) ·
  // __CAMPAIGN_NAME__ (TikTok — yalnız BÜYÜK harf; 'kremi__ekim__2026' makro değil). Doğrusal desenler (ReDoS yok).
  var MACRO_RES = [/\{\{[^{}]*\}\}/, /\{[^{}]*\}/, /__[A-Z0-9_]+__/];
  var UTM_RAW_MAX = 512; // hiçbir desen bundan uzun metinde koşmaz
  // Türkçe harf katlama (toLowerCase'ten önce, yerelden bağımsız). Kaçışlı yazılır: dosya kodlamasından bağımsız.
  var TR_FOLD = {
    '\u0130': 'i', I: 'i', '\u0131': 'i', '\u015E': 's', '\u015F': 's', '\u011E': 'g', '\u011F': 'g',
    '\u00DC': 'u', '\u00FC': 'u', '\u00D6': 'o', '\u00F6': 'o', '\u00C7': 'c', '\u00E7': 'c',
  };
  var TR_FOLD_RE = /[\u0130I\u0131\u015E\u015F\u011E\u011F\u00DC\u00FC\u00D6\u00F6\u00C7\u00E7]/g;
  var PII_SEP_RE = /[\s.,\-+()/]/g; // telefon ayraçları: atılınca rakamlar birleşir
  var KATT_MAX = 200; // sepet özniteliği _katt üst sınırı (sözleşme 5)

  // ── Saf fonksiyonlar ─────────────────────────────────────────────────────────

  /** UTF-8 baytları üzerinden FNV-1a 32 bit (sözleşme §6; sunucu ve uygulamayla birebir). */
  function fnv1a32(str) {
    var enc = encodeURIComponent(String(str));
    var h = 0x811c9dc5;
    for (var i = 0; i < enc.length; i++) {
      var b;
      if (enc.charAt(i) === '%') { b = parseInt(enc.substr(i + 1, 2), 16); i += 2; }
      else b = enc.charCodeAt(i); // encodeURIComponent çıktısı ASCII
      h ^= b;
      h = Math.imul(h, 0x01000193) >>> 0;
    }
    return h >>> 0;
  }

  /** bucket = fnv1a32(vid + ":" + key) % 1000 ; variant = variants[floor(bucket * n / 1000)] */
  function assignVariant(vid, key, variants) {
    if (!vid || !variants || !variants.length) return null;
    var bucket = fnv1a32(vid + ':' + key) % 1000;
    return variants[Math.floor(bucket * variants.length / 1000)];
  }

  /** behavior.ts isSafeSearchTerm ile aynı kural. */
  function isSafeSearchTerm(raw) {
    if (typeof raw !== 'string') return false;
    var t = raw.trim();
    if (t.length < 2 || t.length > 40) return false;
    if (t.indexOf('@') !== -1 || /\d{5,}/.test(t)) return false;
    return t.split(/\s+/).length <= 4;
  }

  /**
   * Yol: query/hash atılır, 200'e kısılır. Hesap ve hediye kartı yolları gizli parça taşır
   * (/account/orders/<imzalı-token>, /account/reset/<id>/<token>, /gift_cards/<id>/<anahtar>) → ilk segmentte kesilir.
   */
  function cleanPath(raw) {
    if (typeof raw !== 'string') return null;
    var p = raw.split(/[?#]/)[0];
    if (p.charAt(0) !== '/') return null;
    var m = /^((?:\/[a-z]{2}(?:-[a-z]{2})?)?\/account)(\/[^/]+)?/i.exec(p);
    if (m) p = m[1] + (m[2] || '');
    else {
      var g = /^((?:\/[a-z]{2}(?:-[a-z]{2})?)?\/gift_cards)(\/|$)/i.exec(p);
      if (g) p = g[1];
    }
    return p.slice(0, 200);
  }

  /*
   * UTM değeri normalleştirme — behavior.ts normalizeToken ile BİREBİR (eşlik tablosu backend
   * packages/core/src/contracts/utm-normalize.fixtures.json; iki tarafın testi aynı dosyayı okur). Sıra önemli:
   *  a. string değilse null; ilk 512 karakter.  b. %-çöz (hata yutulur); kodlu '?'/'&' (%3F/%26) kaldıysa öncesi alınır.
   *  c. makro (ham metinde) → 'macro-unexpanded'.  d. kırp; ilk '?'/'&' sonrası atılır.
   *  h. `pii` (term/content): '@' ya da ayraçsız ≥7 rakam / 5+ ardışık rakam → null (temizlikten ÖNCE).
   *  e. Türkçe harf katlama → küçük harf.  f. boşluk/'+' → '-', [a-z0-9_.-] dışı silinir, ardışık '-' teklenir.
   *  g. `max` karakter kesimi, SONRA baş/son '-' kırpılır; boşsa null.
   */
  function looksPersonal(v) {
    if (v.indexOf('@') !== -1) return true;
    var d = v.replace(PII_SEP_RE, '');
    return /\d{5,}/.test(d) || (d.match(/\d/g) || []).length >= 7;
  }

  function normalizeToken(raw, max, pii) {
    if (typeof raw !== 'string') return null;
    var v = raw.slice(0, UTM_RAW_MAX);
    try { v = decodeURIComponent(v); } catch (e) { /* çözülmemiş hâliyle */ }
    var enc = /%3f|%26/i.exec(v);
    if (enc) v = v.slice(0, enc.index);
    for (var i = 0; i < MACRO_RES.length; i++) if (MACRO_RES[i].test(v)) return 'macro-unexpanded';
    v = v.trim().split(/[?&]/)[0];
    if (pii && looksPersonal(v)) return null;
    v = v.replace(TR_FOLD_RE, function (ch) { return TR_FOLD[ch]; }).toLowerCase()
      .replace(/[\s+]+/g, '-').replace(/[^a-z0-9_.-]/g, '').replace(/-{2,}/g, '-')
      .slice(0, max).replace(/^-+|-+$/g, '');
    return v || null;
  }

  /** utm_source/medium/campaign: ≤60. */
  function normalizeUtmToken(raw) { return normalizeToken(raw, 60, false); }

  /** utm_term/content: ≤80 + kişisel veri koruması. */
  function normalizeUtmTerm(raw) { return normalizeToken(raw, 80, true); }

  /** Açılış URL'sinden utm_source/medium/campaign/term/content (normalleştirilmiş; geçersiz → alan yok). */
  function parseUtm(search) {
    var out = {};
    var q;
    try { q = new URLSearchParams(search || ''); } catch (e) { return out; }
    var keys = { source: 'utm_source', medium: 'utm_medium', campaign: 'utm_campaign', term: 'utm_term', content: 'utm_content' };
    for (var k in keys) {
      var v = k === 'term' || k === 'content' ? normalizeUtmTerm(q.get(keys[k])) : normalizeUtmToken(q.get(keys[k]));
      if (v) out[k] = v;
    }
    return out;
  }

  /**
   * Reklam tıklaması: YALNIZ tür (gclid > gbraid > wbraid > msclkid > fbclid > ttclid > yclid) + sayısal
   * gad_campaignid (≤20 hane) ve gad_source (≤3 hane). Kimlik DEĞERİ hiçbir koşulda dönmez (yalnız "dolu mu" bakılır).
   * Parametre adları büyük/küçük harf duyarsız: elle kurulan/yönlendirilen bağlantıda `GCLID=` da görülür.
   * Aynı parametre birden çok kez varsa ilki geçerlidir (URLSearchParams.get ile aynı).
   */
  function parseClick(search) {
    var out = {};
    var q;
    try { q = new URLSearchParams(search || ''); } catch (e) { return out; }
    var present = {};
    var c = null;
    var s = null;
    q.forEach(function (v, k) {
      var lk = String(k).toLowerCase();
      if (CLICK_ID_TYPES.indexOf(lk) !== -1) { if (v && v.trim()) present[lk] = true; }
      else if (lk === 'gad_campaignid') { if (c === null) c = v; }
      else if (lk === 'gad_source') { if (s === null) s = v; }
    });
    for (var i = 0; i < CLICK_ID_TYPES.length; i++) {
      if (present[CLICK_ID_TYPES[i]]) { out.type = CLICK_ID_TYPES[i]; break; }
    }
    if (c && GAD_CAMPAIGN_RE.test(c)) out.campaignId = c;
    if (s && GAD_SOURCE_RE.test(s)) out.adSource = s;
    return out;
  }

  /*
   * Sepet özniteliği _katt (sözleşme 5): ilk dokunuş atfının kısa JSON'u, ≤200 karakter, boş alan yazılmaz.
   * Okuyan taraf (sipariş atfı) her alanı yeniden doğrular. Sığmayan alan atlanır — öncelik: tıklama → kaynak/ortam/
   * kampanya → term/content. Saklı kayıt elle bozulmuş olabilir → değerler burada da yeniden doğrulanır.
   */
  var KATT_FIELDS = [
    ['k', 'click', 'type'], ['g', 'click', 'campaignId'], ['a', 'click', 'adSource'],
    ['s', 'utm', 'source'], ['m', 'utm', 'medium'], ['c', 'utm', 'campaign'], ['t', 'utm', 'term'], ['n', 'utm', 'content'],
  ];
  function kattValue(key, v) {
    if (typeof v !== 'string') return null;
    if (key === 'k') return CLICK_ID_TYPES.indexOf(v) !== -1 ? v : null;
    if (key === 'g') return GAD_CAMPAIGN_RE.test(v) ? v : null;
    if (key === 'a') return GAD_SOURCE_RE.test(v) ? v : null;
    return key === 't' || key === 'n' ? normalizeUtmTerm(v) : normalizeUtmToken(v);
  }
  function buildKatt(att) {
    if (!att || typeof att !== 'object') return '';
    var o = {};
    var any = false;
    for (var i = 0; i < KATT_FIELDS.length; i++) {
      var f = KATT_FIELDS[i];
      var grp = att[f[1]];
      var v = kattValue(f[0], grp && typeof grp === 'object' ? grp[f[2]] : null);
      if (!v) continue;
      o[f[0]] = v;
      if (JSON.stringify(o).length > KATT_MAX) delete o[f[0]];
      else any = true;
    }
    return any ? JSON.stringify(o) : '';
  }

  /** Harici yönlendirenin YALNIZ alan adı (www. atılmış); site içi / boş / geçersiz → null. */
  function refHost(referrer, ownHost) {
    if (!referrer) return null;
    var h;
    try { h = new URL(referrer).hostname.toLowerCase(); } catch (e) { return null; }
    h = h.replace(/^www\./, '');
    var own = String(ownHost || '').toLowerCase().replace(/^www\./, '');
    if (!h || h === own || !/^[a-z0-9.-]{3,100}$/.test(h)) return null;
    return h;
  }

  /** 22 karakter base64url (16 rastgele bayt). `cryptoLike.getRandomValues` zorunlu. */
  function randomId(cryptoLike) {
    var A = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
    var b = new Uint8Array(16);
    cryptoLike.getRandomValues(b);
    var s = '';
    for (var i = 0; i < 15; i += 3) {
      var n = (b[i] << 16) | (b[i + 1] << 8) | b[i + 2];
      s += A[(n >> 18) & 63] + A[(n >> 12) & 63] + A[(n >> 6) & 63] + A[n & 63];
    }
    var last = b[15]; // kalan 1 bayt → 2 karakter
    return s + A[(last >> 2) & 63] + A[(last << 4) & 63];
  }

  /** Aynı öğeye `windowMs` içinde `limit` tıklama → true (patlama başına bir kez). */
  function createRageDetector(limit, windowMs) {
    limit = limit || 3;
    windowMs = windowMs || 1000;
    var hits = [];
    return function (el, now) {
      hits = hits.filter(function (h) { return now - h.t <= windowMs; });
      hits.push({ el: el, t: now });
      var same = hits.filter(function (h) { return h.el === el; });
      if (same.length >= limit) {
        hits = hits.filter(function (h) { return h.el !== el; });
        return true;
      }
      return false;
    };
  }

  /** Liquid `template.name` → sözleşme sayfa türü (theme.liquid de aynı eşlemeyi yapar; bu yedek/test için). */
  function pageTypeOf(templateName) {
    var n = String(templateName || '');
    if (n === 'index') return 'home';
    if (n.indexOf('customers/') === 0) return 'account';
    return ['product', 'collection', 'search', 'cart', 'page', 'blog', 'article'].indexOf(n) !== -1 ? n : 'other';
  }

  function clamp01(v) {
    return Math.round(Math.min(1, Math.max(0, v)) * 1000) / 1000;
  }

  /** Tıklama konumu: yalnız bölüm içinde `section` + bölüm kutusuna göre x/y (0–1); bölüm dışında {} (klavye tıklamasında x/y yok). */
  function clickPos(secId, rect, cx, cy) {
    if (!secId) return {};
    var o = { section: secId };
    if ((cx || cy) && rect && rect.width > 0 && rect.height > 0) {
      o.x = clamp01((cx - rect.left) / rect.width);
      o.y = clamp01((cy - rect.top) / rect.height);
    }
    return o;
  }

  /**
   * Görünüm sınıfı (10-22, tıklama haritası cihaz ayrımı): tema kırılımları — m < 750 px ≤ t < 990 px ≤ d.
   * Bölüm düzeni sınıfa göre değişir (ör. 2 ↔ 4 sütun); panel ısıyı aynı sınıfın ekran görüntüsünün üstüne çizer.
   */
  function viewportClass(width) {
    var w = Number(width) || 0;
    if (w <= 0) return undefined;
    return w < 750 ? 'm' : w < 990 ? 't' : 'd';
  }

  /**
   * Bölüm kutusu: gölge DOM'lu çekmece/diyalogda (cart-drawer) dış etiket yer kaplamaz (0 yükseklik) → görünen panel
   * gölge kökteki part="content". Eskiden 0 kutu yüzünden sepet çekmecesi tıklamaları hiç x/y almıyordu (10-22).
   */
  function sectionRect(el) {
    if (!el || !el.getBoundingClientRect) return null;
    var r = el.getBoundingClientRect();
    if ((!r || r.width <= 0 || r.height <= 0) && el.shadowRoot && el.shadowRoot.querySelector) {
      var inner = el.shadowRoot.querySelector('[part~="content"]');
      if (inner) r = inner.getBoundingClientRect();
    }
    return r;
  }

  function productIdOf(v) {
    var s = String(v == null ? '' : v);
    var m = /(\d{1,20})$/.exec(s);
    return m ? m[1] : null;
  }

  var pure = {
    fnv1a32: fnv1a32, assignVariant: assignVariant, isSafeSearchTerm: isSafeSearchTerm, cleanPath: cleanPath,
    normalizeUtmToken: normalizeUtmToken, normalizeUtmTerm: normalizeUtmTerm, parseUtm: parseUtm, parseClick: parseClick,
    buildKatt: buildKatt, KATT_MAX: KATT_MAX, CLICK_ID_TYPES: CLICK_ID_TYPES, refHost: refHost, randomId: randomId, createRageDetector: createRageDetector,
    pageTypeOf: pageTypeOf, clickPos: clickPos, viewportClass: viewportClass, sectionRect: sectionRect, productIdOf: productIdOf, FEATURE_ID_RE: FEATURE_ID_RE, PAGE_TYPES: PAGE_TYPES,
  };

  // ── Çalışma zamanı (yalnız tarayıcı) ─────────────────────────────────────────

  function start() {
    var doc = win.document;
    if (!doc || !win.crypto || !win.crypto.getRandomValues) return;
    if (win.__kremiTrackStarted) return; // çift yüklemeye karşı
    win.__kremiTrackStarted = true;

    var cfg = win.KREMI_TRACK || {};
    var pageType = PAGE_TYPES.indexOf(cfg.pageType) !== -1 ? cfg.pageType : 'other';
    var locale = cfg.locale === 'tr' || cfg.locale === 'en' ? cfg.locale : undefined;

    var active = false;
    var apiReady = false;
    var sid = null;
    var vid = null;
    var queue = [];
    var sentCount = 0;
    var timer = null;
    var listeners = [];
    var io = null;
    var mo = null;
    var moTimer = null;
    var seenSections = {};
    var sectionPos = 0;
    var visTimers = new Map();
    var scrollDone = {};
    var scrollTick = false;
    var wishPrev = null;
    var expApplied = []; // [{key, variant}]
    var expStyle = null;
    var rage = null;
    var att = null; // ilk dokunuş atfı (attribution) — page_view + _katt

    // ── depolama / çerez ──
    function ssGet(k) { try { return win.sessionStorage.getItem(k); } catch (e) { return null; } }
    function ssSet(k, v) { try { win.sessionStorage.setItem(k, v); } catch (e) { /* yok say */ } }
    function getCookie(name) {
      var m = new RegExp('(?:^|; )' + name + '=([^;]*)').exec(doc.cookie || '');
      return m && ID_RE.test(m[1]) ? m[1] : null;
    }
    function setCookie(name, value, maxAge) {
      doc.cookie = name + '=' + value + '; path=/; max-age=' + maxAge + '; SameSite=Lax; Secure';
    }
    function delCookie(name) {
      doc.cookie = name + '=; path=/; max-age=0; SameSite=Lax; Secure';
    }

    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      listeners.push([target, type, fn, opts]);
    }

    // ── rıza ──
    function allowed() {
      try {
        var p = win.Shopify && win.Shopify.customerPrivacy;
        return !!(p && typeof p.analyticsProcessingAllowed === 'function' && p.analyticsProcessingAllowed());
      } catch (e) { return false; }
    }

    function evaluate() {
      var ok = allowed();
      if (ok && !active) activate();
      else if (!ok && active) deactivate();
      else if (!ok && apiReady && (getCookie('_kremi_vid') || getCookie('_kremi_sid'))) {
        // Kimlik çerezi var ama rıza yok → bu tarayıcıda DAHA ÖNCE rıza vardı (başka sekmede/oturumda geri alındı).
        // Sepet notu da o dönemden kalmış olabilir → bir kez temizlenir; çerez silindiği için sonraki sayfalarda
        // bu dal tetiklenmez. Rızası hiç olmamış ziyaretçiye istek atılmaz.
        clearIds();
        clearCartAttribution();
        forgetSession();
      }
    }

    function clearIds() {
      delCookie('_kremi_vid');
      delCookie('_kremi_sid');
    }

    /*
     * K8: sepetteki eşleşme notu (_ksid) ve atıf özeti (_katt) boşaltılır — sonradan verilen sipariş oturumla
     * EŞLEŞMEZ, kaynağı da yazılmaz. KOŞULSUZ gönderilir: sepet tarayıcı genelinde ortak, sessionStorage sekmeye
     * özel — notu başka sekme yazmış olabilir, bu sekmenin sessionStorage'ı boş olsa da sepette not durabilir.
     */
    function clearCartAttribution() {
      try {
        win.fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _ksid: '', _katt: '' } }) }).catch(function () {});
      } catch (e) { /* ölçüm asla siteyi bozmaz */ }
    }

    function forgetSession() {
      try { ['kremi_ksid', 'kremi_katt', 'kremi_exp', 'kremi_exp_seen', 'kremi_att'].forEach(function (k) { win.sessionStorage.removeItem(k); }); } catch (e) { /* yok say */ }
    }

    // ── kimlik ──
    function touchSid() {
      var s = getCookie('_kremi_sid') || randomId(win.crypto);
      setCookie('_kremi_sid', s, SID_TTL); // kayan: her olayda yenile
      sid = s;
      return s;
    }

    // ── olay üretimi ──
    function track(name, extra) {
      if (!active || sentCount >= MAX_PER_PAGE) return;
      var e = {
        v: 1, id: randomId(win.crypto), name: name, ts: Date.now(), sid: touchSid(), vid: vid || undefined,
        surface: 'web', locale: locale, page: { type: pageType, path: cleanPath(win.location.pathname) || undefined },
        vp: viewportClass(win.innerWidth),
      };
      if (extra) for (var k in extra) if (extra[k] !== undefined && extra[k] !== null) e[k] = extra[k];
      queue.push(e);
      sentCount++;
      if (queue.length >= MAX_BATCH) flush();
    }

    function send(events) {
      var json = JSON.stringify({ events: events });
      try {
        var nav = win.navigator;
        if (nav && nav.sendBeacon && nav.sendBeacon(EVENT_URL, new Blob([json], { type: 'application/json' }))) return;
      } catch (e) { /* fetch'e düş */ }
      try {
        // eslint-disable-next-line no-undef
        win.fetch(EVENT_URL, { method: 'POST', body: json, keepalive: true, credentials: 'same-origin', headers: { 'Content-Type': 'application/json' } }).catch(function () {});
      } catch (e) { /* ölçüm asla siteyi bozmaz */ }
    }

    function flush() {
      if (!queue.length) return;
      var batch = [];
      var size = 2;
      while (queue.length) {
        var len = JSON.stringify(queue[0]).length + 1;
        if (batch.length && (batch.length >= MAX_BATCH || size + len > MAX_BODY)) { send(batch); batch = []; size = 2; }
        batch.push(queue.shift());
        size += len;
      }
      if (batch.length) send(batch);
    }

    // ── atıf (UTM / yönlendiren / reklam tıklaması) ──
    function attribution() {
      var stored = null;
      try { stored = JSON.parse(ssGet('kremi_att') || 'null'); } catch (e) { stored = null; }
      if (stored && typeof stored !== 'object') stored = null;
      var search = win.location.search;
      var fresh = { utm: parseUtm(search), ref: refHost(doc.referrer, win.location.hostname) || undefined, click: parseClick(search) };
      var hasClick = Object.keys(fresh.click).length > 0;
      var hasFresh = Object.keys(fresh.utm).length > 0 || !!fresh.ref || hasClick;
      /*
       * Oturum ortasında reklam tıklaması geldiyse saklı kayıt bu URL'nin TÜM temasıyla (utm + ref + click)
       * DEĞİŞTİRİLİR. Temas bir bütündür: ilk dokunuşun utm'sine yeni tıklamayı eklemek ("instagram bio" kaynaklı
       * kayda gclid) hiç var olmamış bir karışım üretir — kanal sınıflandırması tıklamayı, kampanya raporu eski
       * utm'yi okur, iki rapor aynı ziyareti farklı yere yazar. Ücretli tıklama bilinçli yeni bir temastır.
       */
      // Saklı kayıt "boş" (doğrudan giriş) ise ilk sinyalli sayfa onun yerine geçer; yalnız tıklamalı kayıt boş SAYILMAZ.
      var storedEmpty = stored && !stored.ref && !Object.keys(stored.utm || {}).length && !Object.keys(stored.click || {}).length;
      if (!stored || hasClick || (storedEmpty && hasFresh)) {
        stored = fresh;
        ssSet('kremi_att', JSON.stringify(stored));
      }
      return stored;
    }

    // ── bölüm görünürlüğü ──
    function sectionId(el) {
      var id = el.getAttribute('data-track-section');
      return id && FEATURE_ID_RE.test(id) ? id : null;
    }

    function scanSections() {
      if (!io) return;
      var nodes = doc.querySelectorAll('[data-track-section]:not([data-ks-obs])');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        el.setAttribute('data-ks-obs', String(sectionPos++));
        io.observe(el);
      }
    }

    function onIntersect(entries) {
      for (var i = 0; i < entries.length; i++) {
        var en = entries[i];
        var vh = win.innerHeight || 1;
        // Viewport'tan uzun bölüm hiçbir zaman %50 orana ulaşamaz → görünen yükseklik ekranın yarısıysa da sayılır.
        var visible = en.isIntersecting && (en.intersectionRatio >= 0.5 || en.intersectionRect.height >= vh * 0.5);
        var el = en.target;
        var id = sectionId(el);
        if (!id || seenSections[id]) continue;
        if (visible) {
          if (!visTimers.has(el)) {
            visTimers.set(el, win.setTimeout(function (target, sid2) {
              visTimers.delete(target);
              if (seenSections[sid2]) return;
              seenSections[sid2] = true;
              io.unobserve(target);
              track('section_view', { el: { id: sid2, pos: Math.min(200, parseInt(target.getAttribute('data-ks-obs'), 10) || 0) } });
            }.bind(null, el, id), 1000));
          }
        } else if (visTimers.has(el)) {
          win.clearTimeout(visTimers.get(el));
          visTimers.delete(el);
        }
      }
    }

    // ── tıklama ──
    function trackTarget(t) {
      var el = t.closest('[data-track]');
      if (!el) return null;
      var id = el.getAttribute('data-track');
      if (!id || !FEATURE_ID_RE.test(id)) return null;
      // data-track bir kapsayıcıdaysa (kart listesi gibi) yalnız İÇİNDEKİ tıklanabilir öğeye tıklama sayılır.
      var inter = t.closest(INTERACTIVE);
      if (!(el.matches(INTERACTIVE) || (inter && el.contains(inter)))) return null;
      return { el: el, id: id };
    }

    function onClick(ev) {
      var t = ev.target;
      if (!t || t.nodeType !== 1) t = t && t.parentElement;
      if (!t || !t.closest) return;
      var now = Date.now();
      var tr = trackTarget(t);
      var secEl = t.closest('[data-track-section]');
      var secId = secEl ? sectionId(secEl) : null;
      var pos = clickPos(secId, secEl && sectionRect(secEl), ev.clientX, ev.clientY);

      if (tr) {
        track('click', Object.assign({ el: { id: tr.id } }, pos));
        if (tr.id === 'cart.checkout') track('checkout_start');
      } else if (secId && !t.closest(INTERACTIVE)) {
        var cursor = '';
        try { cursor = win.getComputedStyle(t).cursor; } catch (e) { /* yok say */ }
        if (cursor !== 'pointer') track('dead_click', Object.assign({ el: { id: secId } }, pos));
      }

      if (rage(t.closest(INTERACTIVE) || t, now)) {
        var rid = tr ? tr.id : secId;
        track('rage_click', Object.assign(rid ? { el: { id: rid } } : {}, pos));
      }
    }

    // ── kaydırma derinliği ──
    function onScroll() {
      if (scrollTick) return;
      scrollTick = true;
      win.requestAnimationFrame(function () {
        scrollTick = false;
        var de = doc.documentElement;
        var total = Math.max(de.scrollHeight, doc.body ? doc.body.scrollHeight : 0);
        if (total <= 0) return;
        var pct = ((win.pageYOffset || de.scrollTop || 0) + (win.innerHeight || 0)) / total * 100;
        [25, 50, 75, 100].forEach(function (d) {
          if (!scrollDone[d] && pct >= (d === 100 ? 99 : d)) { scrollDone[d] = true; track('scroll_depth', { value: d }); }
        });
      });
    }

    // ── sepet ──
    function itemOf(it) {
      if (!it) return null;
      var o = {};
      var p = productIdOf(it.product_id);
      var v = productIdOf(it.variant_id != null ? it.variant_id : it.id);
      if (p) o.productId = p;
      if (v) o.variantId = v;
      var q = parseInt(it.quantity, 10);
      if (q >= 1 && q <= 99) o.qty = q;
      var cents = it.final_price != null ? it.final_price : it.price;
      if (typeof cents === 'number' && cents >= 0 && cents < 1e8) o.price = Math.round(cents) / 100;
      return o;
    }

    function trackAdd(items) {
      (items || []).slice(0, 5).forEach(function (it) {
        var item = itemOf(it);
        if (item) track('add_to_cart', { item: item });
      });
    }

    function ensureKsid() {
      if (!active || !sid) return;
      var katt = buildKatt(att);
      if (ssGet('kremi_ksid') === sid && (ssGet('kremi_katt') || '') === katt) return;
      var mine = sid;
      ssSet('kremi_ksid', mine); // eşzamanlı ikinci çağrıyı keser
      ssSet('kremi_katt', katt);
      try {
        win.fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          // _katt her zaman yazılır (boşsa ''): önceki oturumdan kalan atıf yeni oturumun _ksid'iyle eşleşmesin.
          body: JSON.stringify({ attributes: { _ksid: mine, _katt: katt } }),
        }).then(function (r) { if (!r.ok) ssSet('kremi_ksid', ''); }).catch(function () { ssSet('kremi_ksid', ''); });
      } catch (e) { ssSet('kremi_ksid', ''); }
    }

    // ── deneyler ──
    function applyExperiments(list) {
      if (!active || !vid || !Array.isArray(list)) return;
      var root2 = doc.documentElement;
      list.slice(0, 5).forEach(function (ex) {
        if (!ex || !EXP_RE.test(ex.key) || !Array.isArray(ex.variants)) return;
        var vs = ex.variants.filter(function (v) { return typeof v === 'string' && VARIANT_RE.test(v); });
        if (!vs.length) return;
        var variant = assignVariant(vid, ex.key, vs);
        if (!variant) return;
        root2.setAttribute('data-exp-' + ex.key, variant);
        expApplied.push({ key: ex.key, variant: variant });
        // oturum başına deney başına bir exposure (sid değişirse yeni oturum)
        var seen;
        try { seen = JSON.parse(ssGet('kremi_exp_seen') || 'null'); } catch (e) { seen = null; }
        if (!seen || seen.sid !== sid) seen = { sid: sid, keys: {} };
        if (!seen.keys[ex.key]) {
          seen.keys[ex.key] = 1;
          ssSet('kremi_exp_seen', JSON.stringify(seen));
          var exp = {};
          exp[ex.key] = variant;
          track('experiment_exposure', { exp: exp });
        }
      });
      renderExpCss();
    }

    /*
     * Deney bloğu CSS'i. theme.liquid'deki statik kural JS/rıza yokken yalnız `…:a` varyantını bırakır
     * (html:not([data-exp-ready]) altında `:a` dışındakiler gizli). Burada her anahtar için gösterilecek
     * varyant yazılır: atanmışsa o, atanmamışsa (deney yok / bilinmeyen anahtar) `a`; sonra `data-exp-ready`
     * ile statik kural devre dışı kalır. Rıza geri alınınca (deactivate) hepsi söküp statik hâle dönülür.
     */
    function renderExpCss() {
      var keys = {};
      var nodes = doc.querySelectorAll('[data-exp-show]');
      for (var i = 0; i < nodes.length; i++) {
        var k = (nodes[i].getAttribute('data-exp-show') || '').split(':')[0];
        if (EXP_RE.test(k)) keys[k] = 'a';
      }
      expApplied.forEach(function (e) { keys[e.key] = e.variant; });
      var css = '';
      for (var key in keys) {
        css += '[data-exp-show^="' + key + ':"]:not([data-exp-show="' + key + ':' + keys[key] + '"]){display:none!important}';
      }
      if (!expStyle) {
        expStyle = doc.createElement('style');
        expStyle.setAttribute('data-kremi-exp', '');
        doc.head.appendChild(expStyle);
      }
      expStyle.textContent = css;
      doc.documentElement.setAttribute('data-exp-ready', '');
    }

    function loadExperiments() {
      var cached = null;
      try { cached = JSON.parse(ssGet('kremi_exp') || 'null'); } catch (e) { cached = null; }
      if (cached && Date.now() - cached.t < 60000) { applyExperiments(cached.list); return; }
      try {
        win.fetch(EXP_URL, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            var list = j && Array.isArray(j.experiments) ? j.experiments : [];
            ssSet('kremi_exp', JSON.stringify({ t: Date.now(), list: list }));
            applyExperiments(list);
          })
          .catch(function () { /* hata → deney yok */ });
      } catch (e) { /* deney yok */ }
    }

    // ── etkinleştir / pasifleştir ──
    function activate() {
      active = true;
      vid = getCookie('_kremi_vid') || randomId(win.crypto);
      setCookie('_kremi_vid', vid, VID_TTL);
      touchSid();
      rage = createRageDetector(3, 1000);
      queue = [];
      sentCount = 0;
      seenSections = {};
      sectionPos = 0;
      scrollDone = {};
      wishPrev = null;
      expApplied = [];

      att = attribution();
      var pv = {};
      if (att.utm && Object.keys(att.utm).length) pv.utm = att.utm;
      if (att.ref) pv.ref = att.ref;
      if (att.click && Object.keys(att.click).length) pv.click = att.click;
      track('page_view', pv);

      if (pageType === 'search' && cfg.search) {
        var term = isSafeSearchTerm(cfg.search.term) ? cfg.search.term.trim() : null;
        var cnt = parseInt(cfg.search.count, 10);
        track('search', { term: term || undefined, value: cnt >= 0 ? cnt : undefined });
      }
      if (pageType === 'cart') track('cart_view');

      on(doc, 'click', onClick, { capture: true, passive: true });
      on(win, 'scroll', onScroll, { passive: true });
      on(doc, 'visibilitychange', function () { if (doc.visibilityState === 'hidden') flush(); });
      on(win, 'pagehide', flush);

      // Tema olayları (bubbles → document'a ulaşır)
      on(doc, 'variant:add', function (e) {
        trackAdd(e.detail && e.detail.items);
        ensureKsid();
      });
      on(doc, 'kremi:cart:added', function (e) { trackAdd(e.detail && e.detail.items); }); // favori sayfası / UGC "hemen al"
      on(doc, 'cart:change', ensureKsid);
      // Sepet çekmecesi açılışı: <cart-drawer> "dialog:after-show" yayar (bubbles YOK) → yakalama evresinde dinlenir.
      on(doc, 'dialog:after-show', function (e) {
        if (e.target && e.target.tagName === 'CART-DRAWER') track('cart_view');
      }, true);
      on(doc, 'facet:update', function () { track('filter', { el: { id: 'collection.filters' } }); });
      on(doc, 'kremi:wishlist:changed', function (e) {
        var items = (e.detail && e.detail.items) || [];
        var cur = {};
        items.forEach(function (i) { if (i && i.productGid) cur[i.productGid] = 1; });
        if (wishPrev) { // ilk olay yalnız taban çizgisi (sayfa açılışındaki liste yüklemesi)
          Object.keys(cur).filter(function (g) { return !wishPrev[g]; }).slice(0, 3).forEach(function (g) {
            track('wishlist_add', { item: { productId: productIdOf(g) || undefined } });
          });
          Object.keys(wishPrev).filter(function (g) { return !cur[g]; }).slice(0, 3).forEach(function (g) {
            track('wishlist_remove', { item: { productId: productIdOf(g) || undefined } });
          });
        }
        wishPrev = cur;
      });

      if ('IntersectionObserver' in win) {
        io = new win.IntersectionObserver(onIntersect, { threshold: [0, 0.25, 0.5, 0.75, 1] });
        scanSections();
        // Ajax ile değişen içerik (ürün/koleksiyon yeniden çizimi) yeni bölüm getirebilir.
        if ('MutationObserver' in win && doc.body) {
          mo = new win.MutationObserver(function () {
            if (moTimer) return;
            moTimer = win.setTimeout(function () { moTimer = null; scanSections(); }, 600);
          });
          mo.observe(doc.body, { childList: true, subtree: true });
        }
      }

      timer = win.setInterval(flush, FLUSH_MS);
      loadExperiments();
    }

    function deactivate() {
      active = false;
      queue = []; // GÖNDERİLMEDEN boşalt
      if (timer) { win.clearInterval(timer); timer = null; }
      if (moTimer) { win.clearTimeout(moTimer); moTimer = null; }
      listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
      listeners = [];
      if (io) { io.disconnect(); io = null; }
      if (mo) { mo.disconnect(); mo = null; }
      visTimers.forEach(function (t) { win.clearTimeout(t); });
      visTimers.clear();
      var obs = doc.querySelectorAll('[data-ks-obs]');
      for (var i = 0; i < obs.length; i++) obs[i].removeAttribute('data-ks-obs');
      expApplied.forEach(function (e) { doc.documentElement.removeAttribute('data-exp-' + e.key); });
      expApplied = [];
      if (expStyle) { expStyle.remove(); expStyle = null; }
      doc.documentElement.removeAttribute('data-exp-ready'); // statik "yalnız :a" kuralına dön
      clearCartAttribution(); // koşulsuz (çok sekme: bu sekmenin sessionStorage'ı boş olabilir)
      forgetSession();
      clearIds();
      sid = null;
      vid = null;
      att = null;
    }

    // ── rıza API'sini yükle, kararı dinle ──
    doc.addEventListener('visitorConsentCollected', function () { apiReady = true; evaluate(); });
    function ready() { apiReady = true; evaluate(); }
    if (win.Shopify && win.Shopify.customerPrivacy) ready();
    else if (win.Shopify && typeof win.Shopify.loadFeatures === 'function') {
      try {
        win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          if (!error) ready();
        });
      } catch (e) { /* API yok → hiçbir şey yapma */ }
    }
  }

  pure.start = start;
  return pure;
});
